import { ENDPOINTS } from '@config/endpoints';
import { authedJsonFetch, AuthedJsonFetchResult } from '@services/base/authed-json-fetch';
import { PaymentsDeleteBankCardRequestData, PaymentsDeleteBankCardResponseData, PaymentsDeleteBankCardResponseDto } from '@services/dto/payments';
import { paymentsDeleteBankCardResponseFromDto } from '@mapping/payments';
type PaymentsDeleteBankCard = (requestData: PaymentsDeleteBankCardRequestData) => AuthedJsonFetchResult<PaymentsDeleteBankCardResponseData>;
export const paymentsDeleteBankCard: PaymentsDeleteBankCard = requestData => {
  const {
    promise,
    cancel
  } = authedJsonFetch<PaymentsDeleteBankCardResponseDto>(ENDPOINTS.payments.deleteBankCard(requestData),
  //
  {
    method: 'DELETE'
  });
  return {
    promise: promise.then(paymentsDeleteBankCardResponseFromDto),
    cancel
  };
};